export abstract class NgDownloadService {
    abstract preview(url: string, fileName: string): Promise<any>;
}
